"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Breadcrumb = _styledComponents.default.div.withConfig({
  displayName: "Breadcrumb",
  componentId: "p1drdf-0"
})(["margin:0;a{font-size:0.875rem;font-weight:", ";line-height:1.5;&:before{pointer-events:none;}&:only-child:not([aria-current='true']):before{content:'\u2190 Back to ';}}@media ", "{a{&:not([aria-current='true']):before{content:'\u2190 Back to ';}&:not(:only-child):not(:nth-last-child(2)){display:none;}}}@media ", "{a:not(:first-child):before{content:'/';display:inline-block;color:", ";padding:0 8px;}}"], (0, _helpers.fontWeight)('regular'), (0, _helpers.breakpoint)('maxMobile'), (0, _helpers.breakpoint)('minTablet'), (0, _helpers.color)('dark-1'));

var _default = Breadcrumb;
exports.default = _default;